"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("./../colors"));
const sizes_1 = __importDefault(require("./../sizes"));
const fonts_1 = __importDefault(require("./../fonts"));
exports.default = {
    baseStyle: {
        borderRadius: sizes_1.default.btnRadius,
        _text: {
            fontFamily: fonts_1.default.bold,
        },
        _stack: {
            space: sizes_1.default.btnIconMargin,
        },
    },
    sizes: {
        lg: {
            px: "20",
            py: "16",
            _text: {
                fontSize: "md",
            },
        },
        md: {
            px: "16",
            py: "12",
            _text: {
                fontSize: "sm",
            },
        },
        sm: {
            px: "12",
            py: "8",
            _text: {
                fontSize: "xs",
            },
        },
        xs: {
            px: "10",
            py: "4",
            _text: {
                fontSize: "xs",
            },
        },
    },
    variants: {
        solid: (props) => {
            const { colorScheme: c } = props;
            let bg = `${c}.500`;
            if (props.isDisabled) {
                bg = `muted.800`;
            }
            else if (props.isLoading) {
                bg = `muted.900`;
            }
            let color = "#ffffff";
            switch (c) {
                case colors_1.default.btnPrimary.name:
                    color = colors_1.default.colorBtnPrimaryText;
                    break;
                case colors_1.default.btnSecondary.name:
                    color = colors_1.default.colorBtnSecondaryText;
                    break;
                case colors_1.default.btnWhite.name:
                    color = colors_1.default.colorTextPrimary;
                    break;
                default:
                    break;
            }
            const styleObject = {
                _text: {
                    color: color,
                },
                _web: {
                    outlineWidth: "0",
                },
                bg,
                _hover: {
                    bg: `${c}.600`,
                },
                _pressed: {
                    bg: `${c}.700`,
                },
                _focus: {
                    bg: `${c}.600`,
                },
                _loading: {
                    bg: `${c}.500`,
                    opacity: "50",
                },
                _disabled: {
                    bg: `trueGray.300`,
                },
            };
            return styleObject;
        },
    },
    defaultProps: {
        colorScheme: "btnPrimary",
        variant: "solid",
        size: {
            base: "md",
            md: "lg",
        },
    },
};
